module.exports = __webpack_public_path__ + "562b57608dae693337a1c5569223d39f.woff2";